module.exports = __webpack_public_path__ + "img/peter-matthews.a0e1aae5.png";